import { initializeApp } from 'firebase/app';
import { getAnalytics, setConsent } from 'firebase/analytics';
import { doc, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';

const config = {
	apiKey: process.env.REACT_APP_API_KEY,
	authDomain: process.env.REACT_APP_AUTH_DOMAIN,
	databaseURL: process.env.REACT_APP_DATABASE_URL,
	projectId: process.env.REACT_APP_PROJECT_ID,
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_APP_ID,
	measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

const db = 'prayers';

class Firebase {
	constructor() {		
		this.app = initializeApp(config);
		this.firestore = initializeFirestore(this.app, {
			localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
			experimentalForceLongPolling: true
		});
		this.analytics = getAnalytics(this.app);
	}

	// Analytics API
	doSetConsent = (ConsentStatusString) => {
		setConsent({
			'ad_storage': ConsentStatusString,
			'analytics_storage': ConsentStatusString
		});
	}

	// Firestore Database API
	prayer = (id) => doc(this.firestore, `${db}`, `${id}`);
}

export default Firebase;